/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkbookItemType = {
    BusinessUnitsAreaChart: 'BusinessUnitsAreaChart',
    CompaniesBarChart: 'CompaniesBarChart',
    CompanyExpenditureChart: 'CompanyExpenditureChart',
    CompanyBusinessUnitTreemap: 'CompanyBusinessUnitTreemap',
    CompanyCategoryTreemap: 'CompanyCategoryTreemap',
    CategoriesAreaChart: 'CategoriesAreaChart',
    GenericBarChart: 'GenericBarChart',
    GenericTreemap: 'GenericTreemap',
    DataTable: 'DataTable',
    BusinessUnitsTable: 'BusinessUnitsTable',
    CategoriesTable: 'CategoriesTable',
    TextDocument: 'TextDocument'
} as const;
export type WorkbookItemType = typeof WorkbookItemType[keyof typeof WorkbookItemType];


export function instanceOfWorkbookItemType(value: any): boolean {
    for (const key in WorkbookItemType) {
        if (Object.prototype.hasOwnProperty.call(WorkbookItemType, key)) {
            if (WorkbookItemType[key as keyof typeof WorkbookItemType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkbookItemTypeFromJSON(json: any): WorkbookItemType {
    return WorkbookItemTypeFromJSONTyped(json, false);
}

export function WorkbookItemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkbookItemType {
    return json as WorkbookItemType;
}

export function WorkbookItemTypeToJSON(value?: WorkbookItemType | null): any {
    return value as any;
}

export function WorkbookItemTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): WorkbookItemType {
    return value as WorkbookItemType;
}

